import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import {
  hideOwnershipModal,
  takeQueueItem,
  hideRtkModal,
  showRtkModal
} from 'actions';

import WorkflowQueues from 'components/WorkflowQueues';
import ChangeOwnershipModal from 'components/Modals/ChangeOwnershipModal';
import ReasonToKnowModal from 'components/Modals/ReasonToKnowModal';
import withContainerErrorBoundary from 'components/ErrorBoundaries/ContainerErrorBoundary/withContainerErrorBoundary';

class ReasonToKnows extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    changeOwnershipItem: PropTypes.shape(),
    isOwnershipModalShown: PropTypes.bool,
    isRtkModalShown: PropTypes.bool,
    rtkId: PropTypes.number
  };

  static defaultProps = {
    permissions: null,
    changeOwnershipItem: null,
    isOwnershipModalShown: false,
    isRtkModalShown: false,
    rtkId: null
  };

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(hideOwnershipModal());
  }

  reAssignItem() {
    const { dispatch, changeOwnershipItem } = this.props;

    if (changeOwnershipItem != null && changeOwnershipItem.id != null) {
      dispatch(takeQueueItem('cic', changeOwnershipItem.id));
      dispatch(hideOwnershipModal());
    }
  }

  continueFromOwnershipModal() {
    const { dispatch, changeOwnershipItem } = this.props;
    dispatch(hideOwnershipModal());
    dispatch(showRtkModal(changeOwnershipItem.id));
  }

  closeFromOwnershipModal() {
    const { dispatch } = this.props;
    dispatch(hideOwnershipModal());
  }

  closeRtkModal() {
    const { dispatch } = this.props;

    dispatch(hideRtkModal());
  }

  render() {
    const {
      permissions,
      isOwnershipModalShown,
      changeOwnershipItem,
      rtkId,
      isRtkModalShown
    } = this.props;

    return (
      <div className="container rtks-panel">
        <div className="panel no-border">
          <div className="panel-body bordered">
            <WorkflowQueues workflowType="cic" permissions={ permissions } />
          </div>
        </div>
        { changeOwnershipItem != null && <ChangeOwnershipModal
          isShown={ isOwnershipModalShown }
          onAssign={ () => this.reAssignItem() }
          onContinueWithoutAssign={ () => this.continueFromOwnershipModal() }
          onCancel={ () => this.closeFromOwnershipModal() }
          workflowRecord={ changeOwnershipItem }
        /> }
        { rtkId != null && <ReasonToKnowModal
          isShown={ isRtkModalShown }
          onClose={ () => this.closeRtkModal() }
          id={ rtkId }
        /> }
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    auth: {
      permissions
    },
    rtks: {
      rtkId,
      isRtkModalShown
    },
    workflow: {
      isOwnershipModalShown,
      changeOwnershipItem
    }
  } = state;
  return {
    permissions,
    isOwnershipModalShown,
    changeOwnershipItem,
    rtkId,
    isRtkModalShown
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withContainerErrorBoundary(ReasonToKnows, 'ReasonToKnows'));
